import { HTMLAttributes } from 'react';
import { cn } from '@/src/utils';

export interface LocalIconProps extends HTMLAttributes<HTMLSpanElement> {
  iconSrc: string;
  iconSize?: number;
  onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  className?: string;
  onPointerDown?: (e: React.PointerEvent<HTMLSpanElement>) => void;
}

const LocalIcon = ({
  iconSrc,
  iconSize = 16,
  onClick,
  onPointerDown,
  className,
  ...props
}: LocalIconProps) => {
  const defaultStyle: React.CSSProperties = {
    flexShrink: 0,
    background: `url(${iconSrc}) center center/contain`,
    backgroundRepeat: 'no-repeat',
    width: `${iconSize}px`,
    height: `${iconSize}px`,
  };

  return (
    <span
      className={cn('inline-block', className)}
      onClick={onClick}
      onPointerDown={onPointerDown}
      style={
        onClick || onPointerDown
          ? { cursor: 'pointer', ...defaultStyle }
          : { ...defaultStyle }
      }
      {...props}
    />
  );
};

export default LocalIcon;
